export type ReviewReason =
  | "no_property_match"
  | "property_not_found"
  | "no_unit_match"
  | "no_contact_method"
  | "incomplete_contact";

export interface ReviewItem {
  id: number;
  status?: string;
  reason: ReviewReason;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  phone: string | null;
  subject: string | null;
  original_body: string | null;
  message: string | null;
  property_hint: string | null;
  best_guess_property_id: number | null;
  best_guess_property_name: string | null;
  best_guess_unit_id: number | null;
  best_guess_unit_name: string | null;
  detected_source_name: string | null;
  received_via: string | null;
  created_at: string;
}

export interface ReviewQueueResponse {
  items: ReviewItem[];
  total_count: number;
  page_count: number;
  current_page: number;
}

export const REVIEW_ITEMS_PENDING_QUERY_KEY = [
  "LEAD_INGEST_REVIEW_ITEMS",
  "pending"
] as const;

export const LEAD_INGEST_ADDRESS_QUERY_KEY = ["LEAD_INGEST_ADDRESS"] as const;
